module.exports = __webpack_public_path__ + "img/375.342c2a73.jpg";